/**
 * tasks.ts — status unificado de geração assíncrona (contrato: schemas/tasks.py).
 */

import type { components } from './generated/api'
import { api } from './http'

export type StatusTask = components['schemas']['StatusTask']
export type EstadoTask = StatusTask['estado']
export type TipoTask = StatusTask['recurso']['tipo']

export const ESTADOS_TERMINAIS: ReadonlySet<EstadoTask> = new Set([
  'CONCLUIDO',
  'FALHOU',
  'AGUARDANDO_SELECAO', // terminal para o POLLING (ação humana pendente)
])

export function statusTask(tipo: TipoTask, id: number) {
  return api<StatusTask>(`/api/v1/tasks/${tipo}/${id}`)
}
